import { helpers } from '@vuelidate/validators';
import { nameRegex as validNamePattern } from '@constants/validation';

export const nameRegex = helpers.regex(new RegExp(validNamePattern));
